// @flow
import type { ReduxState } from '../../types';

const getSeoUtils = (state: ReduxState) => state.seoUtils;

export const getSeoIsHeader = (state: ReduxState) => {
  const seo = getSeoUtils(state);
  return seo?.isHeader;
};
